module.exports = __webpack_public_path__ + "bundle.2.b50a8ed668c818711529.worker.js"